import { useQuery } from "@tanstack/react-query"
import type { User } from "@medusajs/medusa"
import medusaRequest from "../../services/request"
import {
  chatwootIdentityState,
  type ChatwootIdentityResponse,
  type ChatwootIdentityState,
} from "./chatwoot-preview"

/**
 * The widget's identity for this session. The API signs the logged-in admin from the session cookie; this sends no
 * user id.
 */
export const useChatwootIdentity = (
  enabled: boolean,
  user: Omit<User, "password_hash"> | undefined
): ChatwootIdentityState => {
  const query = useQuery(
    // Profile fields are in the key so an edit (which refetches the session) re-signs with the new name and email.
    [
      "chatwoot_identity",
      user?.id,
      user?.email,
      user?.first_name,
      user?.last_name,
      user?.updated_at,
    ],
    async () =>
      (
        await medusaRequest<ChatwootIdentityResponse>(
          "GET",
          "/admin/chatwoot/identity"
        )
      ).data,
    { enabled: enabled && !!user, retry: false, staleTime: Infinity }
  )
  return chatwootIdentityState(query)
}
